import { render, staticRenderFns } from "./StatusStudentCounts.vue?vue&type=template&id=3708917b&scoped=true&"
import script from "./StatusStudentCounts.vue?vue&type=script&lang=js&"
export * from "./StatusStudentCounts.vue?vue&type=script&lang=js&"
import style0 from "./StatusStudentCounts.vue?vue&type=style&index=0&id=3708917b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3708917b",
  null
  
)

export default component.exports